import React from "react";
import "./styles/GenbuttonTopBanner.css";

const GenbuttonTopBanner = ({
  text,
  size,
  event,
  borderColor,
  active = false,
  shadow = false,
  link,
}) => {
  const clickHandler = () => {
    try {
      if (event) {
        event();
      }
      if (link) {
        window.open(link, "_blank");
      }
    } catch (error) {}
  };

  return (
    <button
      onClick={() => clickHandler()}
      className={`buttonTopBanner ${size} ${borderColor} ${
        shadow ? "shadow" : "background"
      } ${active ? "active" : ""}`}
    >
      {text}
    </button>
  );
};

export default GenbuttonTopBanner;
